/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { ApiResponse, Branding } from '@core/models';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'app/services/api.service';

@Injectable()
export class BrandingService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  getBranding(clientId: number): Observable<ApiResponse<Branding>> {
    return this.http
      .get<ApiResponse<Branding>>(`${this.apiService.superAdminApi}/branding/${clientId}`)
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  addUpdateBranding(branding: Branding, clientId: number, logActivity = true): Observable<ApiResponse<Branding>> {
    return this.http
      .post<ApiResponse<Branding>>(
        `${this.apiService.superAdminApi}/branding/${clientId}?logActivity=${logActivity}`,
        branding
      )
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  deleteBranding(clientId: number): Observable<ApiResponse> {
    return this.http
      .delete<ApiResponse>(`${this.apiService.superAdminApi}/branding/${clientId}`)
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }
}
